import { useEffect, useRef, useState } from "react";

export function useCountUp(target, duration = 900) {
  const [val, setVal] = useState(0);
  const raf = useRef();
  useEffect(() => {
    const t0 = performance.now();
    const to = Number(target) || 0;
    const step = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(to * eased));
      if (p < 1) raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [target, duration]);
  return val;
}

export function Odometer({ value, className = "", ...rest }) {
  const v = useCountUp(value);
  return (
    <span className={className} {...rest}>
      {v.toLocaleString()}
    </span>
  );
}

export function Gauge({ value = 0, max = 100, size = 72, color = "#E60012", label, testId }) {
  const stroke = 5;
  const r = (size - stroke * 2) / 2;
  const midY = r + stroke;
  const arcLen = Math.PI * r;
  const pctTarget = Math.max(0, Math.min(100, ((Number(value) || 0) / max) * 100));
  const pct = useCountUp(pctTarget, 1000);
  const shown = useCountUp(value, 1000);
  const d = `M ${stroke} ${midY} A ${r} ${r} 0 0 1 ${size - stroke} ${midY}`;
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((f) => {
    const ang = Math.PI * (1 - f);
    return {
      x1: size / 2 + Math.cos(ang) * (r - 4),
      y1: midY - Math.sin(ang) * (r - 4),
      x2: size / 2 + Math.cos(ang) * (r - 8),
      y2: midY - Math.sin(ang) * (r - 8),
    };
  });
  return (
    <div className="inline-flex flex-col items-center shrink-0" data-testid={testId}>
      <svg width={size} height={midY + stroke} viewBox={`0 0 ${size} ${midY + stroke}`} className="overflow-visible">
        <path d={d} fill="none" stroke="var(--line, #26262C)" strokeWidth={stroke} />
        <path d={d} fill="none" stroke={color} strokeWidth={stroke} strokeDasharray={`${(pct / 100) * arcLen} ${arcLen}`} />
        {ticks.map((t, i) => (
          <line key={i} x1={t.x1} y1={t.y1} x2={t.x2} y2={t.y2} stroke="var(--line-2, #3A3A42)" strokeWidth={1} />
        ))}
      </svg>
      <div className="font-mono text-white leading-none" style={{ fontSize: Math.max(12, size * 0.22), fontWeight: 700, marginTop: -size * 0.18 }}>
        {shown}
      </div>
      {label && (
        <div className="label-mono mt-1" style={{ fontSize: 8 }}>
          {label}
        </div>
      )}
    </div>
  );
}
